var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodPressure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2967,
    cy: 40.2967,
    r: 37.7782,
    fill: "#D7D4F8",
    stroke: "#845BB3",
    strokeWidth: 5.03709
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3579 27.4416C37.3579 27.4416 46.1728 37.3584 46.1728 43.235C46.1728 48.0979 42.2208 52.0499 37.3579 52.0499C32.495 52.0499 28.543 48.0979 28.543 43.235C28.543 37.3584 37.3579 27.4416 37.3579 27.4416ZM52.0494 32.9509V41.7658H49.1111V32.9509H52.0494ZM49.1111 47.6424H52.0494V44.7041H49.1111V47.6424Z",
    fill: "#845BB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodPressure);
export default __webpack_public_path__ + "static/media/blood-pressure.45b305877bf2a13b55d63eb36b6fe2fe.svg";
export { ForwardRef as ReactComponent };